import { FC } from 'react';
import { noop } from 'remeda';
import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import EmbeddedMap from '@bridebook/web/app-shared/components/embedded-map/embedded-map';

const TEMP_supplier = {
  name: 'Addington Palace Data - Test Copy',
  address: {
    country: 'GB',
    city: 'Croydon',
    postalCode: 'CR0 5BB',
    street: ['Gravel Hill'],
    adminArea: ['Greater London', 'England'],
  },
  flags: { hideStreet: false },
} as ISupplier;

interface IProps {
  supplier?: ISupplier;
}

export const SupplierMap: FC<IProps> = ({ supplier: receivedSupplier }) => {
  const supplier = receivedSupplier || TEMP_supplier;
  const showMap = supplier.address && !supplier.flags?.hideStreet;

  const onMapMouseUp = noop;
  const onMapInView = noop;

  if (!showMap) return null;

  return (
    <EmbeddedMap
      onMouseUp={onMapMouseUp}
      onMapInView={onMapInView}
      supplierName={supplier.name}
      supplierCity={supplier.address.city}
      supplierCountry={supplier.address.country}
      supplierPostalCode={supplier.address.postalCode}
    />
  );
};
